<template>

    <div class="UserIndexTitle">
        <img :src="imgURL" alt="">
        <span>{{title}}</span>
    </div>

</template>

<script>
    export default {
        name: "UserIndexTitle",
        props:{
            title:{
                type:String,
                default:''
            },
            imgURL:{
                type:String,
                default:''
            }
        },
        data() {
            return {
                
            }
        },
        mounted() {
            
        },
        
    }
</script>

<style scoped lang="less">
.UserIndexTitle{
    margin-bottom:15px;
    display:flex;
    align-items:center;
    font-weight: bold;
    font-size: 18px;
    img{
        margin-right:10px;
        width:16px;
    }
}
</style>
